export default __webpack_public_path__ + "static/03.07-8d5b50218ead0029e17571fd2ef7bc50.png";